import { DatesAndShifts } from "./dates-and-shifts.model";

export interface SpecificationLockStatus {
  isLocked: boolean;
  activatedAt: string | null;
  deactivatedAt: string | null;
  lockedByUser: { userId: number; name: string } | null;
}

export class Order {
  id: string;
  upisId: string;
  unit: string;
  materialId: string;
  name: string;
  status: string;
  quantity: number;
  materialQuantity: number;
  isSelected: boolean;
  numberOfMaterials: string;
  client: string;
  assigneeId: string;
  assigneeName: string;
  assigneePhoto: string;
  deliveryAddress: string;
  contactPhone: string;
  description: string;
  deliveryDeadline: Date;
  documentationDeadline: Date;
  productionDeadline: Date;
  engineerDocumentationDeadline: Date;
  partialDeliveryDate: Date;
  materials: Array<any>;
  deadline: string;
  operations: Array<any>;
  timeCorrectionEmployee: number;
  timeEstimatedEmployee: number;
  timeConsumedEmployeeTotal: number;
  timePlannedEmployee: number;
  timePlannedEmployeeTotal: number;
  dates: Array<DatesAndShifts>;
  documentationListStatus: string;
  materialsListStatus: string;
  operationsListStatus: string;
  lastOperationQuantity: number;
  lastOperationQuantityFinished: number;
  lastOperationTotalQuantity: number;
  quantityPlanned: number;
  comment: string;
  numberOfPackages: number;
  numberOfPallets: number;
  numberOfRowsPerPallet: number;
  numberOfPackagesInRow: number;
  grossWeight: number;
  netWeight: number;
  assignees: any;
  materialSector: string;
  sectors: any;
  upisData: any;
  upisUpdateConfirmed: boolean;
  additionalPlanningRequired: boolean;
  deviationFromPlan: boolean;
  isActive: boolean;
  quantityIssued: number;
  quantityReturned: number;
  quantityConsumed: number;
  isReserved: boolean;
  isReturned: boolean;
  procurementComment: string;
  originalMaterialName: string;
  originalMaterialUnit: string;
  originalMaterialId: string;
  userPhoto: string;
  userName: string;
  workOrderQuantity: number;
  plannedByUserPhoto: string;
  plannedByUserName: string;
  issuedByUserName: string;
  issuedByUserPhoto: string;
  requestedByUserName: string;
  requestedByUserPhoto: string;
  partialDeliveryInfo: Array<PartialDeadline>
  hasOperations: boolean;
  isPriority: boolean;
  documents: Array<Document>;
  jobType: Array<String>;
  graphicDocumentationCompletionDate: Date;
  engineerDocumentationCompletionDate: Date;
  graphicMaterialsCompletionDate: Date;
  engineerMaterialsCompletionDate: Date;
  greenDate: boolean;
  plannedSectors: Array<string>;
  startDevelopmentDate: Date;
  developmentDeadline: Date;
  receiptOfRequestDate: Date;
  engineerAgreementDate: Date;
  graphicAgreementDate: Date;
  productId: string;
  productName: string;
  productArticleCode: string;
  zerothSample: string;
  workOrderUnit: string;
  quantityCorrection: number;
  offerId: string;
  offerUpisId: string;
  operationsSignal: boolean;
  materialsSignal: boolean;
  documentationSignal: boolean;
  upisIdForOffer: string;
  workRequestId: string;
  workRequestUpisId: string;
  isShiftDataComplete: boolean;
  filteredShifts: Array<FilteredShift>;
  deliveredWorkOrderUpisId: string;
  ord: number;
  isForDeliveryList: boolean;
  shippingMethod: string;
  complexity: number;

  constructor(order: any) {
    this.id = order.id || order.workOrderId || undefined;
    this.upisId = order.upisId || order.workOrderUpisId || undefined;
    this.unit = order.unit || undefined;
    this.materialId = order.workOrderMaterialId || undefined;
    this.name = order.name || order.workOrderName || undefined;
    this.status = order.status || order.workOrderStatus || undefined;
    this.numberOfMaterials = order.numberOfMaterials || undefined;
    this.quantity = order.quantity || undefined;
    this.materialQuantity = order.materialQuantity || undefined;
    this.client = order.client || undefined;
    this.assigneeId = order.assigneeId || undefined;
    this.assigneeName = order.assigneeName || undefined;
    this.assigneePhoto = order.assigneePhoto || undefined;
    this.deliveryAddress = order.deliveryAddress || undefined;
    this.contactPhone = order.contactPhone || undefined;
    this.description = order.description || undefined;
    this.deliveryDeadline = order.deliveryDeadline || undefined;
    this.documentationDeadline = order.documentationDeadline || undefined;
    this.productionDeadline = order.productionDeadline || undefined;
    this.engineerDocumentationDeadline = order.engineerDocumentationDeadline || undefined;
    this.materials = order.materials || undefined;
    this.deadline = order.deadline || undefined;
    this.operations = order.workOrderOperations || undefined;
    this.timeCorrectionEmployee = order.timeCorrectionEmployee || undefined;
    this.timeEstimatedEmployee = order.timeEstimatedEmployee || 0;
    this.timeConsumedEmployeeTotal = order.timeConsumedEmployeeTotal || 0;
    this.timePlannedEmployee = order.timePlannedEmployee || undefined;
    this.timePlannedEmployeeTotal = order.timePlannedEmployeeTotal || 0;
    this.dates = order.dates || [];
    this.documentationListStatus = order.documentationListStatus || undefined;
    this.materialsListStatus = order.materialsListStatus || undefined;
    this.operationsListStatus = order.operationsListStatus || undefined;
    this.lastOperationQuantity = order.lastOperationQuantity || undefined;
    this.lastOperationQuantityFinished = order.lastOperationQuantityFinished || undefined;
    this.quantityPlanned = order.quantityPlanned || undefined;
    this.lastOperationTotalQuantity = order.lastOperationTotalQuantity || undefined;
    this.comment = order.comment || undefined;
    this.numberOfPackages = order.numberOfPackages || undefined;
    this.numberOfPallets = order.numberOfPallets || undefined;
    this.numberOfRowsPerPallet = order.numberOfRowsPerPallet || undefined;
    this.numberOfPackagesInRow = order.numberOfPackagesInRow || undefined;
    this.grossWeight = order.grossWeight || undefined;
    this.netWeight = order.netWeight || undefined;
    this.assignees = order.assignees || undefined;
    this.materialSector = order.materialSector || undefined;
    this.sectors = order.sectors || undefined;
    this.upisData = order.upisData || undefined;
    this.upisUpdateConfirmed = order.upisUpdateConfirmed || undefined;
    this.additionalPlanningRequired = order.additionalPlanningRequired || undefined;
    this.deviationFromPlan = order.deviationFromPlan || undefined;
    this.isActive = order.isActive || undefined;
    this.quantityIssued = order.quantityIssued || 0;
    this.quantityReturned = order.quantityReturned || 0;
    this.quantityConsumed = order.quantityConsumed || 0;
    this.isReserved = order.isReserved || undefined;
    this.isReturned = order.isReturned || undefined;
    this.procurementComment = order.procurementComment || undefined;
    this.originalMaterialName = order.originalMaterialName || undefined;
    this.originalMaterialUnit = order.originalMaterialUnit || undefined;
    this.originalMaterialId = order.originalMaterialId || undefined;
    this.userPhoto = order.userPhoto || undefined;
    this.userName = order.userName || undefined;
    this.workOrderQuantity = order.workOrderQuantity || undefined;
    this.plannedByUserPhoto = order.plannedByUserPhoto || undefined;
    this.plannedByUserName = order.plannedByUserName || undefined;
    this.issuedByUserName = order.issuedByUserName || undefined;
    this.issuedByUserPhoto = order.issuedByUserPhoto || undefined;
    this.requestedByUserName = order.requestedByUserName || undefined;
    this.requestedByUserPhoto = order.requestedByUserPhoto || undefined;
    this.partialDeliveryInfo = order.partialDeliveryInfo || undefined;
    this.hasOperations = order.hasOperations || true;
    this.isPriority = order.isPriority || undefined;
    this.documents = order.documents || undefined;
    this.jobType = order.jobType || undefined;
    this.graphicDocumentationCompletionDate = order.graphicDocumentationCompletionDate || undefined;
    this.engineerDocumentationCompletionDate = order.engineerDocumentationCompletionDate || undefined;
    this.graphicMaterialsCompletionDate = order.graphicMaterialsCompletionDate || undefined;
    this.engineerMaterialsCompletionDate = order.engineerMaterialsCompletionDate || undefined;
    this.greenDate = order.greenDate || undefined;
    this.plannedSectors = order.plannedSectors || undefined;
    this.startDevelopmentDate = order.startDevelopmentDate || undefined;
    this.developmentDeadline = order.developmentDeadline || undefined;
    this.receiptOfRequestDate = order.receiptOfRequestDate || undefined;
    this.engineerAgreementDate = order.engineerAgreementDate || undefined;
    this.graphicAgreementDate = order.graphicAgreementDate || undefined;
    this.productId = order.productId || undefined;
    this.productName = order.productName || undefined;
    this.productArticleCode = order.productArticleCode || undefined;
    this.zerothSample = order.zerothSample || undefined;
    this.workOrderUnit = order.workOrderUnit || undefined;
    this.quantityCorrection = order.quantityCorrection || undefined;
    this.offerId = order.offerId || undefined;
    this.offerUpisId = order.offerUpisId || undefined;
    this.partialDeliveryDate = order.partialDeliveryDate || undefined;
    this.operationsSignal = order.operationsSignal || undefined;
    this.materialsSignal = order.materialsSignal || undefined;
    this.documentationSignal = order.documentationSignal || undefined;
    this.upisIdForOffer = order.upisIdForOffer || undefined;
    this.workRequestId = order.workRequestId || undefined;
    this.workRequestUpisId = order.workRequestUpisId || undefined;
    this.isShiftDataComplete = order.isShiftDataComplete || undefined;
    this.filteredShifts = order.filteredShifts || undefined;
    this.deliveredWorkOrderUpisId = order.deliveredWorkOrderUpisId || null;
    this.ord = order.ord || null;
    this.isForDeliveryList = order.isForDeliveryList || undefined;
    this.shippingMethod = order.shippingMethod || undefined;
    this.complexity = order.complexity || undefined;
  }
}

class PartialDeadline {
  date: Date;
  comment: string;
  quantity: number;
}

class Document {
  url: string;
  name: string;
  isApproved: boolean;
}

class FilteredShift {
  date: string;
  name: string;
  shiftNumber: string;
  sector: string;
  quantityPlanned: number;
  quantityFinished: number;
  timePlannedEmployee: number;
  timeConsumedEmployee: number;
}

